import React, { useState } from 'react';
import { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import { postAccountAddress } from '../../../store/actions/account/accountActions';
import { getCurrentAccountUid } from '../../../store/selectors/accountSelectors';
import SectionLoader from '../../Loader/SectionLoader';
import { getStatesOptions } from '../../../util/helpers/addressHelper';
import { addNewAddressValidationSchema } from '../../../validation/addAddressValidationSchema';
import { USA_COUNTRY_ISO3CODE } from '../../../util/constants';
import { selectStates } from '../../../store/selectors/commonSelectors';
import DeliveryAddressForm from '../../AddressForm/DeliveryAddressForm';

const uLayoutStyle = css`
  height: 100%;

  form {
    height: 100%;
  }
`;

const AddDeliveryAddress = ({
  onButtonClick,
  handleNext,
  setError,
  isAddingCCFlow,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const accountUid = useSelector(getCurrentAccountUid);

  const states = useSelector(selectStates);
  const STATES_OPTIONS = getStatesOptions(states);

  const handleSubmitAddress = (values) => {
    const addressPayload = {
      Street: `${values.AddressLine} ${
        values.AddressLine2 && values.AddressLine2
      }`,
      City: values.City,
      PostalCode: values.PostalCode,
      State: values.StateRegion,
      CountryIso3Code: isAddingCCFlow
        ? values.CountryIso3Code
        : USA_COUNTRY_ISO3CODE,
      TagType: values.TagType,
      TagNote: values.CustomTagName,
    };
    dispatch(
      postAccountAddress({
        accountUid,
        data: {
          ...addressPayload,
        },
        handleNext,
        onButtonClick,
        setIsLoading,
        setError,
      }),
    );
  };

  return (
    <SectionLoader isLoading={isLoading}>
      <ModalBody css={uLayoutStyle}>
        <Formik
          initialValues={{
            CountryIso3Code: USA_COUNTRY_ISO3CODE,
            AddressLine: '',
            AddressLine2: '',
            City: '',
            StateRegion: '',
            PostalCode: '',
            TagType: '',
            TagNote: '',
          }}
          onSubmit={handleSubmitAddress}
          validationSchema={addNewAddressValidationSchema}
          enableReinitialize
        >
          {({ isValid, values, setFieldValue }) => (
            <Form>
              <DeliveryAddressForm
                stateOptions={STATES_OPTIONS}
                setFieldValue={setFieldValue}
                {...values}
                // selectedTag={selectedTag}
                // setSelectedTag={setSelectedTag}
                // selectedTag={values.TagType}
                values={values}
                isAddingCCFlow={isAddingCCFlow}
              />
              <ModalButtons
                isVertical
                showOnlySecondary
                marginTop
                secondaryButtonProps={{
                  type: 'submit',
                  textTransform: 'capitalize',
                  label: t('buyWizard.saveAndContinue'),
                  disabled: !isValid,
                }}
              />
            </Form>
          )}
        </Formik>
      </ModalBody>
    </SectionLoader>
  );
};

AddDeliveryAddress.propTypes = {
  onButtonClick: PropTypes.func,
  handleNext: PropTypes.func,
  setError: PropTypes.func,
  isAddingCCFlow: PropTypes.bool,
};

export default AddDeliveryAddress;
